<template>
  <span name="state" v-if="!this.params.value">
    <vs-chip class="ag-grid-cell-chip" :color="color">
      <span>{{ paramValue }}</span>
    </vs-chip>
  </span>
  <div v-else-if="anyTransaction">
    <vs-chip class="ag-grid-cell-chip transform-6" :color="color">
      <span>{{ paramValue }}</span>
    </vs-chip>
    <vs-chip class="ag-grid-cell-chip transform-6" :color="color">
      <span>{{ getTransactionCount }} {{ $t('Table.Transactions.ErrorTransaction') }}</span>
    </vs-chip>
  </div>
  <span v-else name="state">
    <vs-chip class="ag-grid-cell-chip" :color="color">
      <span>{{ paramValue }}</span>
    </vs-chip>
  </span>
</template>

<script>
export default {
  name: "CellTransactionState",
  computed: {
    paramValue() {
      var extendPayText =
        this.$options.filters.currency(this.params.data.PaidAmount) + " ";
      return !this.params.value
        ? (this.params.data.PaidAmount > 0.0 ? extendPayText : "") +
            this.$t("Table.Transactions.Status1")
        : this.$t("Table.Transactions.Status2");
    },
    anyTransaction() {
      return (
        this.params.data.Invoice.Transactions &&
        this.params.data.Invoice.Transactions.length > 0
      );
    },
    getTransactionCount() {
      return this.params.data.Invoice.Transactions &&
        this.params.data.Invoice.Transactions.length > 0
        ? this.params.data.Invoice.Transactions.length
        : 0;
    },
    color() {
      return !this.params.value ? "success" : "danger";
    }
  }
};
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success), 0.15);
    color: rgba(var(--vs-success), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning), 0.15);
    color: rgba(var(--vs-warning), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger), 0.15);
    color: rgba(var(--vs-danger), 1) !important;
    font-weight: 500;
  }
}
.ag-grid-cell-chip.transform-6 {
  transform: translateY(6%);
}
</style>
